import { Group, SimpleGrid, Text } from "@mantine/core";
import { IconSearchOff } from "@tabler/icons-react";
import { ProductCategory, ProductChoice } from "./product";
import { ProductCard } from "./SingleProductCard";
import { ProductTypeV2 } from "/@/generated/graphql";

type SearchPanelProps = {
  categories: ProductCategory[];
  selectedType: ProductTypeV2 | null;
  onSelect: (choice: ProductChoice) => void;
};

// A product type can belong to several categories (e.g. the space maintainer):
// in search results it is shown once, with its first occurrence.
const uniqueByType = (choices: ProductChoice[]) => {
  const seen = new Set<ProductTypeV2>();
  return choices.filter(choice => {
    if (seen.has(choice.type)) return false;
    seen.add(choice.type);
    return true;
  });
};

export const SearchPanel = (props: SearchPanelProps) => {
  const choices = uniqueByType(
    props.categories.flatMap(category => category.choices)
  );

  if (choices.length === 0) {
    return (
      <Group gap="s4" py="s6" px="p3" c="ink.4">
        <IconSearchOff size={17} />
        <Text fz="h4" c="ink.4">
          Aucun produit ne correspond.
        </Text>
      </Group>
    );
  }

  return (
    <SimpleGrid cols={{ base: 2, md: 4 }} spacing="s3">
      {choices.map(choice => (
        <ProductCard
          key={choice.type}
          type={choice.type}
          label={choice.label}
          description={choice.description}
          tag={choice.tag}
          icon={choice.icon}
          isSelected={props.selectedType === choice.type}
          onClick={() => props.onSelect(choice)}
        />
      ))}
    </SimpleGrid>
  );
};
